var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('common-table',{ref:"table",attrs:{"limitHeight":true,"url":_vm.url,"table-columns":_vm.tableColumns,"permission":_vm.permission,"searchs":_vm.searchs,"form-fields":_vm.formFields,"operate":_vm.operate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }